









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DirectionsLink extends Vue {
  @Prop({ required: true }) private address!: string;
}
